import React, { useState, useEffect } from "react";
import ModalHeader from "../../../components/ui/ModalHeader";
import { InputField } from "../../../components/common/InputField";
import { SelectField } from "../../../components/common/SelectField";
import UploadedBanner from "../../../components/common/UploadBanner";
import { PlanOverviewModalConfigInput } from "../../../config/allWorkout";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";

const PlanOverviewModal = ({
                             jsonData,
                             onOpenModal,
                             onClose,
                             setSelectedImageUrl,
                             setSelectedVideoUrl,
                             imageUrl, videoUrl,
                             setUploadedJson
                           }) => {
  const { imageUrls: bannerOptions, videoUrls: videoOptions } = useMediaStore();

  const [formData, setFormData] = useState({
    planName: "",
    duration: "",
    level: "",
    location: "",
    training_type: "",
    description: "",
    banner_image: "",
    plan_video: "",  
  });

  useEffect(() => {
    if (jsonData) {
      setFormData((prev) => ({
        ...prev,
        planName: jsonData.plan_name || jsonData.workout_name || "",
        duration: jsonData.estimated_duration || "",
        level: jsonData.level || "",
        location: jsonData.location || "",
        training_type: jsonData.training_type || "",
        description: jsonData.description || "",
        banner_image: jsonData.banner_image || imageUrl || "",
        plan_video: jsonData.plan_video || videoUrl || ""
      }));
    }
  }, [jsonData,imageUrl, videoUrl]);

  const handleChange = (key, value) => {
    setFormData((prev) => {
      const updatedFormData = { ...prev, [key]: value };

      if (key === "banner_image") {
        setSelectedImageUrl(value);
      } else if (key === "plan_video") {
        setSelectedVideoUrl(value);
      }

      return updatedFormData;
    });

    setUploadedJson((prev) => {
      const updatedFormData = { ...prev, [key]: value };
      return updatedFormData;
    });
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        aria-labelledby="planOverviewModal"
        aria-hidden="true"
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <ModalHeader onClose={onClose} />
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <h5>Plan Overview</h5>
                  {PlanOverviewModalConfigInput.map((field, index) => {
                    if (field.id === "bannerImageUrl" || field.id === "videoUrl") {
                      return (
                        <>
                        <SearchableSelectField
                          key={index}
                          label={field.valueKey === "banner_image" ? 'Image Name' : field.valueKey === "plan_video" ? 'Video Name': field.label}
                          id={field.id}
                          options={
                            field.valueKey === "banner_image"
                              ? bannerOptions
                              : videoOptions
                          }
                          value={formData[field.valueKey]}
                          disabled={field.disabled}
                          onChange={(value) =>
                            handleChange(field.valueKey, value)
                          }
                        />
                        </>
                      );
                    } else if (field.type === "select") {
                      return (
                        <SelectField
                          key={index}
                          label={field.label}
                          id={field.id}
                          options={field.options}
                          value={formData[field.valueKey]}
                          onChange={(e) => handleChange(field.valueKey, e.target.value)}
                          disabled={field.disabled}
                        />
                      );
                    } else if (field.type === "textarea") {
                      return (
                        <div className="mb-3" key={index}>
                          <label htmlFor={field.id} className="form-label">
                            {field.label}
                          </label>
                          <textarea
                            className="form-control"
                            id={field.id}
                            rows={field.rows}
                            value={formData[field.valueKey]}
                            onChange={(e) => handleChange(field.valueKey, e.target.value)}
                            disabled={field.disabled}
                          />
                        </div>
                      );
                    } else {
                      return (
                        <InputField
                          key={index}
                          label={field.label}
                          type={field.type}
                          id={field.id}
                          value={formData[field.valueKey]}
                          onChange={(e) => handleChange(field.valueKey, e.target.value)}
                          disabled={field.disabled}
                        />
                      );
                    }
                  })}
                </div>

                <div className="col-sm-6">
                  <UploadedBanner defaultImage={formData.banner_image} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={onOpenModal}
                aria-label="Save and proceed to the next step"
              >
                Save & Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default PlanOverviewModal;